import { Datatype } from '@framework/engine';
import { createApplicantDataType } from './ApplicantDataTypes';

const CompanyApplicantDataTypesAll = {
  companyName: createApplicantDataType('companyName', {
    label: 'Azienda: Denominazione',
    type: Datatype.String,
  }),
  companyVatNumber: createApplicantDataType('companyVatNumber', {
    label: 'Azienda: Partita IVA',
    type: Datatype.String,
  }),
  companyFiscalNumber: createApplicantDataType('companyFiscalNumber', {
    label: 'Azienda: Codice Fiscale',
    type: Datatype.String,
  }),
  companyLegalForm: createApplicantDataType('companyLegalForm', {
    label: 'Azienda: Forma giuridica',
    type: Datatype.String,
  }),
  companyCountry: createApplicantDataType('companyCountry', {
    label: 'Azienda: Paese',
    type: Datatype.String,
  }),
  companyAddress: createApplicantDataType('companyAddress', {
    label: 'Azienda: Indirizzo',
    type: Datatype.String,
  }),
  companyMunicipality: createApplicantDataType('companyMunicipality', {
    label: 'Azienda: Comune',
    type: Datatype.String,
  }),
  companyPostalCode: createApplicantDataType('companyPostalCode', {
    label: 'Azienda: CAP',
    type: Datatype.String,
  }),
  companyProvince: createApplicantDataType('companyProvince', {
    label: 'Azienda: Provincia',
    type: Datatype.String,
  }),
  companyEmail: createApplicantDataType('companyEmail', {
    label: 'Azienda: Indirizzo e-mail',
    type: Datatype.String,
  }),
  companyPec: createApplicantDataType('companyPec', {
    label: 'Azienda: PEC',
    type: Datatype.String,
  }),
  companyRea: createApplicantDataType('companyRea', {
    label: 'Azienda: Codice REA',
    type: Datatype.String,
  }),
  companyAteco: createApplicantDataType('companyAteco', {
    label: 'Azienda: Codice ATECO',
    type: Datatype.String,
  }),
};

type CompanyApplicantDataTypesSchema = typeof CompanyApplicantDataTypesAll;
export type CompanyApplicantDataKey = keyof CompanyApplicantDataTypesSchema;

export type ICompanyApplicantData = {
  [K in keyof CompanyApplicantDataTypesSchema]: string | undefined;
};

export class CompanyApplicantDataTypes {
  static Map = CompanyApplicantDataTypesAll;

  static List = Object.values(CompanyApplicantDataTypesAll);

  static Codes = Object.keys(CompanyApplicantDataTypesAll) as Array<
    keyof typeof CompanyApplicantDataTypesAll
  >;

  /**
   * Ritorna true se la chiave passata è una chiave di dati aziendali.
   * (e.g. companyName, companyFiscalNumber, ...)
   */
  static isCompanyDataCode(key: string): key is CompanyApplicantDataKey {
    return this.Codes.includes(key as CompanyApplicantDataKey);
  }
}
